import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ILanguageModel } from "../models/languege.model";

// Define a service using a base URL and expected endpoints
export const languageApi = createApi({
    reducerPath: "languageApi",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_IS_DEV
            ? `${process.env.PUBLIC_URL}/static/`
            : process.env.REACT_APP_SCENARIO_API,
    }),
    endpoints: (builder) => ({
        getLanguage: builder.query<ILanguageModel, void>({
            query: () => `language.json`,
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetLanguageQuery } = languageApi;
